"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const createScriptTag = scriptData => {
  const attributes = Object.keys(scriptData);
  const element = document.createElement('script');
  attributes.forEach(attribute => {
    element[attribute] = scriptData[attribute];
  });
  element.defer = true;
  return element;
};
var _default = createScriptTag;
exports.default = _default;